import type { Rng } from '@fg/rng';
import { SPAWN } from '../config';

const TOTAL_WEIGHT = SPAWN.weights.reduce((a, b) => a + b, 0);

export function pickNextTier(rng: Rng): number {
  let r = rng.next() * TOTAL_WEIGHT;
  for (let tier = 0; tier < SPAWN.weights.length; tier++) {
    r -= SPAWN.weights[tier];
    if (r <= 0) return tier;
  }
  return SPAWN.weights.length - 1;
}
